import React, { type ReactElement } from 'react';
import Link from 'next/link';
import Text from '@/common/components/text/text.component';
import LeftArrow from '~/public/assets/images/svg/arrow-left.svg';
import { type Link as LinkType } from './customer-support-drawer-content.component';

interface Props {
  link: LinkType;
  hideIcon?: boolean;
}

export default function CustomerSupportLink({
  link,
  hideIcon = false,
}: Props): ReactElement {
  const content = (
    <>
      <div className="flex items-center gap-x-2">
        {!hideIcon && (
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-silver-200/55">
            {link.icon}
          </div>
        )}
        <Text className="pt-1 text-sm font-medium text-black-400">
          {link.title}
        </Text>
      </div>
      <div className="ml-1 flex items-center gap-x-2">
        {link.description && (
          <div className="pt-2.5 text-sm font-medium text-blue-default">
            {link.description}
          </div>
        )}
        <LeftArrow className="mt-1.5 text-blue-default" />
      </div>
    </>
  );

  if (!link.href) {
    return (
      <div className="mb-2 flex h-11 w-full items-center justify-between rounded-md">
        {content}
      </div>
    );
  }

  return (
    <Link
      href={link.href}
      className="mb-2 flex h-11 w-full items-center justify-between rounded-md"
      target={link.target || ''}
      rel={link.target === '_blank' ? 'noopener noreferrer' : undefined}
    >
      {content}
    </Link>
  );
}
